<template>
  <div>
    <button
      type="button"
      class="btn btn-sm btn-outline-secondary"
      data-testid="sales-schedule-open"
      @click="scheduleOpen = true"
    >
      <FontAwesomeIcon icon="fa-solid fa-calendar" class="me-1" />
      {{ $t("forwards.sales_strategy.schedule_open") }}
    </button>

    <PoolReleaseScheduleModal v-model="scheduleOpen" :schedule />
  </div>
</template>

<script setup lang="ts">
import type { SalesTimeline } from "@/forwards2/forwardsTypes";
import PoolReleaseScheduleModal from "@/forwards2/pools/PoolReleaseScheduleModal.vue";
import { ref } from "vue";

/**
 * Opens the pool's sales schedule: when its strategy releases the listed volume, this sales year
 * and the next. It sits with the listing (under the listing in the full form, in the new-pool
 * summary), since what it shows is the listing's volume, released over time.
 */
defineProps<{
  /** The preview's schedule; null while there is no preview to read it from. */
  schedule: SalesTimeline[] | null;
}>();

const scheduleOpen = ref(false);
</script>
